var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTauBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 32,
    viewBox: "0 0 63 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9591 2.18457H22.9021V31.9999H27.9591V16.8142H29.9125C31.0351 16.8142 31.9463 15.9031 31.9463 14.7805V11.7573H27.9591V2.18457Z",
    fill: "#00A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.05696 16.8142H16.2956V11.7573H5.05696V7.24153H17.9277V2.18457H0V27.6279H17.7649C18.8875 27.6279 19.7987 26.7167 19.7987 25.5942V22.571H5.05696V16.8142Z",
    fill: "#00A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M57.3621 2.18457V20.0679C57.3621 23.8648 54.2839 26.943 50.487 26.943C46.69 26.943 43.6119 23.8648 43.6119 20.0679V2.18457H38.5549V20.0679C38.5549 26.6575 43.8973 31.9999 50.487 31.9999C57.0767 31.9999 62.419 26.6575 62.419 20.0679V2.18457H57.3621Z",
    fill: "#00A9FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.9591 0H22.9021V29.8153H27.9591V14.6297H29.9125C31.0351 14.6297 31.9463 13.7185 31.9463 12.5959V9.57271H27.9591V0Z",
    fill: "#1E0E7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.05696 14.6297H16.2956V9.57271H5.05696V5.05696H17.9277V0H0V25.4434H17.7649C18.8875 25.4434 19.7987 24.5322 19.7987 23.4096V20.3864H5.05696V14.6297Z",
    fill: "#1E0E7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.3621 0V17.8833C57.3621 21.6802 54.2839 24.7584 50.487 24.7584C46.69 24.7584 43.6119 21.6802 43.6119 17.8833V0H38.5549V17.8833C38.5549 24.473 43.8973 29.8153 50.487 29.8153C57.0767 29.8153 62.419 24.473 62.419 17.8833V0H57.3621Z",
    fill: "#1E0E7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTauBig);
export default __webpack_public_path__ + "static/media/logo_tau_big.683b5e5c6bdf904347e34b938a0bc7cc.svg";
export { ForwardRef as ReactComponent };